import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeBlogArticleQuote'
 * @name TypeBlogArticleQuoteFields
 * @type {TypeBlogArticleQuoteFields}
 * @memberof TypeBlogArticleQuote
 */
export interface TypeBlogArticleQuoteFields {
    /**
     * Field type definition for field 'name' (name)
     * @name name
     * @localized false
     */
    name?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'content' (content)
     * @name content
     * @localized false
     */
    content: EntryFieldTypes.RichText;
    /**
     * Field type definition for field 'quotee' (quotee)
     * @name quotee
     * @localized false
     */
    quotee?: EntryFieldTypes.Symbol;
}

/**
 * Entry skeleton type definition for content type 'blogArticleQuote' (Blog Article Quote)
 * @name TypeBlogArticleQuoteSkeleton
 * @type {TypeBlogArticleQuoteSkeleton}
 * @author 3QfgNsR8Bna6Vwl54wI1fJ
 * @since 2025-12-02T22:53:22.414Z
 * @version 5
 */
export type TypeBlogArticleQuoteSkeleton = EntrySkeletonType<TypeBlogArticleQuoteFields, "blogArticleQuote">;
/**
 * Entry type definition for content type 'blogArticleQuote' (Blog Article Quote)
 * @name TypeBlogArticleQuote
 * @type {TypeBlogArticleQuote}
 * @author 3QfgNsR8Bna6Vwl54wI1fJ
 * @since 2025-12-02T22:53:22.414Z
 * @version 5
 */
export type TypeBlogArticleQuote<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeBlogArticleQuoteSkeleton, Modifiers, Locales>;

export function isTypeBlogArticleQuote<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeBlogArticleQuote<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blogArticleQuote'
}
